import React from 'react';
import { Routes, Route, Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';

import NoAccess from '../Common/NoAccess';
import Teams from './Teams';
import Contacts from './Contacts';

export const Volunteer = () => {
    const local = useSelector((state) => state.org.remember);
    const permissions = useSelector((state) => state[local ? 'localUser' : 'user'].permissions).split(',');
    const modules = useSelector((state) => state.org.modules);

    return (
        <>
            <Routes>
                <Route element={<ProtectedRoute isAllowed={permissions.indexOf('Edit volunteer') >= 0 && modules.indexOf('Schedule') >= 0} />}>Schedule
                    <Route index element={<Teams />} />
                    <Route path="teams" element={<Teams />} />
                </Route>
                <Route element={<ProtectedRoute isAllowed={permissions.indexOf('View user') >= 0} />}>
                    <Route path="contacts" element={<Contacts />} />
                </Route>
                <Route path="*" element={<div className="error-404">There's nothing here: 404!</div>} />
            </Routes>
        </>
    );
};

export default Volunteer;

const ProtectedRoute = ({ isAllowed, children }) => {
    if (!isAllowed) {
      return <NoAccess />;
    } else 
      return <>
        {children ? children : <Outlet />}
      </>;
};